import React, { useCallback, useState } from 'react'
import { useField, useFormikContext } from 'formik'
import { FormControlLabel, FormHelperText, Radio, RadioGroup, Stack } from '@mui/material'
import type { ResponsiveStyleValue } from '@mui/system'

interface Props {
  name: string
  values: FieldOption[]
  optionDirection?: ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'> | undefined
  defaultValue?: string | number | undefined
  disabled?: boolean
}

interface FieldOption {
  label: string
  value: string | number
}

/**
 *
 * TODO: fix wrong property references and remove eslint- and ts-ignores
 */
const ToggleField: React.VFC<Props> = ({ values, name, defaultValue, optionDirection = 'row', disabled = false }) => {
  const [localDefault] = useState(defaultValue)
  const [field] = useField(name)
  const { setFieldValue, errors } = useFormikContext<{ [key: string]: unknown }>()
  const fieldError = errors[field.name]

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setFieldValue(name, event.currentTarget.value)
    },
    [name, setFieldValue]
  )

  const options = values.map((option, index) => (
    <FormControlLabel value={option.value} key={index} control={<Radio />} label={option.label} disabled={disabled} />
  ))

  return (
    <Stack>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={localDefault}
        value={field.value || ''}
        name={name}
        onChange={handleChange}
      >
        <Stack direction={optionDirection}>{options}</Stack>
      </RadioGroup>
      {fieldError && <FormHelperText error>{fieldError}</FormHelperText>}
    </Stack>
  )
}

export default ToggleField
